import { render, staticRenderFns } from "./Arcole.vue?vue&type=template&id=1d21f4ca&"
import script from "./Arcole.vue?vue&type=script&lang=ts&"
export * from "./Arcole.vue?vue&type=script&lang=ts&"
import style0 from "./Arcole.vue?vue&type=style&index=0&id=1d21f4ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports